import { Component, OnInit } from '@angular/core';
import { AbandonedBuyflowDAO } from '../../../core/services/dao/abandonedBuyflowDAO';
import { PostsDAO } from '../../../core/services/dao/postsDAO';
import { take } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  sortByDate,
  sortCaseInsensitive,
} from '../../../core/pure-functions/grids/grid-sorting-helper';
import { NameEditButtonComponent } from '../profile/captain/boatyard/form/services-and-pricing/line-item-actions/nameEditButton/nameEditButton.component';
import { EditButtonComponent } from '../../shared/listGrid/editButton/editButton.component';
import { Post } from 'anchor-shared/lib/model/entity/posts';

@Component({
  selector: 'app-posts',
  templateUrl: './posts.component.html',
  styleUrls: ['./posts.component.scss'],
})
export class PostsComponent implements OnInit {
  posts: Post[];
  pageState = 'home';
  columnDefs: any[];
  rowData: any[];
  editPath = 'manage/admin/posts/edit-post';

  constructor(
    private readonly postsDAO: PostsDAO,
    private readonly router: Router,
    private sanitizer: DomSanitizer,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.postsDAO
      .getAll()
      .pipe(take(1))
      .subscribe((posts) => {
        console.log(posts);
        this.columnDefs = this.createColumnDefs();
        this.posts = posts;
        this.rowData = this.posts;
        console.log(this.columnDefs, this.rowData, this.posts);
      });
  }

  private createColumnDefs() {
    return [
      {
        headerName: 'ID',
        field: 'id',
        filter: 'text',
      },
      {
        headerName: 'Route',
        field: 'trailingUrl',
        filter: 'text',
        comparator: sortCaseInsensitive,
      },
      {
        headerName: 'Created',
        field: 'createdAt',
        filter: 'date',
        comparator: sortByDate,
      },
      {
        headerName: 'Updated',
        field: 'updatedAt',
        filter: 'date',
        comparator: sortByDate,
      },
    ];
  }
}
